import * as ImgManipulator from './WebShims/ImageManipulator'
import moment from 'moment'
import { Dimensions } from 'react-native-web'
import dom from 'react-dom'

import {
    POPOVER_DESKTOP_WIDTH,
    POPOVER_DESKTOP_WIDTH_V2,
    POPOVER_MOBILE_WIDTH,
    POPOVER_TABLET_WIDTH,
    POPOVER_TABLET_WIDTH_V2,
    SIDEBAR_MENU_WIDTH,
} from '../components/styles/global'
import { MODAL_EDGE_GAP } from '../components/styles/modals'
import store from '../redux/store'
import {
    hideFloatPopup,
    hideNoteAltShortcuts,
    hideNoteCtrlShortcuts,
    hideShortcuts,
    resetOpenModal,
    setShortcutFocusTasks,
    showNoteAltShortcuts,
    showNoteCtrlShortcuts,
    showShortcuts,
} from '../redux/actions'
import Backend from './BackendBridge'
import { registerPopupDismiss } from './popupDismissGuard'
import { centerPopoverInWindow, clampToRange } from './popoverPositioning'
import { formatLastEditDate } from '../i18n/relativeTime'
import { getDateFormat } from '../components/UIComponents/FloatModals/DateFormatPickerModal'
import { BACKWARD_COMMENT, FORDWARD_COMMENT } from '../components/Feeds/Utils/HelperFunctions'
import { DONE_STEP, OPEN_STEP } from '../components/TaskListView/Utils/TasksHelper'
import { updateQuotaTraffic } from './backends/Premium/premiumFirestore'
import { compareWorkflowEntries, getWorkflowStepsIdsSorted as getSortedWorkflowStepIds } from './workflowOrder'
import { FIXED_MODAL_TOP_OFFSET } from './fixedModalPosition'
import { getSafeAreaInsets } from './safeAreaInsets'
import { getWorkspaceViewport, getWorkspaceInsets } from './workspaceViewport'
import { getSafeAreaModalMaxWidth } from './modalSafeArea'

class HelperFunctions {
    static isValidEmail = email => {
        const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
    }

    static getFirstName = fullName => {
        return fullName ? fullName.replace('#', '').trim().split(' ')[0] : ''
    }

    static getFNameFLastN = fullName => {
        return fullName.replace('#', '').trim().split(' ').slice(0, 2).join(' ')
    }

    static getDifference = (array1, array2) => {
        return array1.filter(x => !array2.includes(x))
    }

    static getIntersection = (array1, array2) => {
        return array1.filter(x => array2.includes(x))
    }

    static resizeImage = async (imageURI, size, base64 = true) => {
        return ImgManipulator.manipulateAsync(imageURI, [{ resize: { height: size } }], {
            compress: 1,
            format: ImgManipulator.SaveFormat.JPEG,
            base64: base64,
        })
    }

    static convertURItoBlob = async (uri, name = 'picture', contentType = 'image/png') => {
        return await fetch(uri)
            .then(r => r.blob())
            .then(blobFile => new File([blobFile], name, { type: contentType }))
    }

    static setRootStyles = () => {
        let css = '*:focus {outline: none}'
        let head = document.head || document.getElementsByTagName('head')[0]
        let style = document.createElement('style')

        head.appendChild(style)

        style.setAttribute('id', 'root-style')
        style.setAttribute('type', 'text/css')
        if (style.styleSheet) {
            // This is required for IE8 and below.
            style.styleSheet.cssText = css
        } else {
            style.appendChild(document.createTextNode(css))
        }
    }
}

export const MODAL_MAX_HEIGHT_GAP = MODAL_EDGE_GAP * 2
export const MENTION_MODAL_MIN_HEIGHT = 150

export const chronoKeysOrder = (a, b) => {
    if (a < b) {
        return -1
    } else {
        return 1
    }
}

export const chronoKeysOrderDesc = (a, b) => {
    if (a < b) {
        return 1
    } else {
        return -1
    }
}

export const chronoEntriesOrder = (a, b) => {
    return compareWorkflowEntries(a, b)
}

export const chronoEntriesOrderDesc = (a, b) => {
    if (a[0] < b[0]) {
        return 1
    } else {
        return -1
    }
}

export const getWorkflowStepsIdsSorted = workflow => {
    return getSortedWorkflowStepIds(workflow)
}

export const getCommentDirectionWhenMoveTaskInTheWorklfow = (stepToMoveIndex, workflowStepsIds, stepHistory) => {
    if (stepToMoveIndex === OPEN_STEP) {
        return BACKWARD_COMMENT
    } else if (stepToMoveIndex === DONE_STEP) {
        return FORDWARD_COMMENT
    } else {
        const currentStepId = stepHistory[stepHistory.length - 1]
        const currentStepIndex = workflowStepsIds.indexOf(currentStepId)
        return stepToMoveIndex > currentStepIndex ? FORDWARD_COMMENT : BACKWARD_COMMENT
    }
}

export const getWorkflowStepId = (stepToMoveIndex, workflowStepsIds) => {
    return stepToMoveIndex === OPEN_STEP || stepToMoveIndex === DONE_STEP
        ? stepToMoveIndex
        : workflowStepsIds[stepToMoveIndex]
}

export const getDayName = (date, inUpperCase = true) => {
    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    const dayName = weekdays[moment(date).isoWeekday() - 1]
    return inUpperCase ? dayName.toUpperCase() : dayName
}

export const parseDate = (date, format, inUpperCase = true) => {
    const dateFormated = date.format(format)
    const currentDateFormated = moment().format(format)
    const tommorowDateFormated = moment().add(1, 'days').format(format)

    let toShowDate = dateFormated

    if (currentDateFormated === dateFormated) {
        toShowDate = inUpperCase ? 'TODAY' : 'Today'
    } else if (tommorowDateFormated === dateFormated) {
        toShowDate = inUpperCase ? 'TOMORROW' : 'Tomorrow'
    }

    return toShowDate
}

export const parsePastDate = (date, format) => {
    const dateFormated = date.format(format)
    const currentDateFormated = moment().format(format)
    const yesterdayDateFormated = moment().add(-1, 'days').format(format)
    let toShowDate = dateFormated

    if (currentDateFormated === dateFormated) {
        toShowDate = 'Today'
    } else if (yesterdayDateFormated === dateFormated) {
        toShowDate = 'Yesterday'
    }

    return toShowDate
}

const getScrollOffsets = () => {
    if (typeof window === 'undefined') {
        return { scrollX: 0, scrollY: 0 }
    }

    const doc = typeof document !== 'undefined' ? document : undefined
    const docElement = doc?.documentElement
    const body = doc?.body

    // The scroll can live on the window OR on the body: with the RNW 0.21
    // layout the body is its own scroll container, so window.pageYOffset is 0
    // (not undefined!) while body.scrollTop carries the real offset — a ??
    // chain never reaches it and popovers positioned with these offsets land
    // above the scrolled viewport (Stage 2 QA: comment modal only visible
    // after scrolling). Use || so zeros fall through to the actual scroller.
    const scrollX = window.pageXOffset || docElement?.scrollLeft || body?.scrollLeft || 0

    const scrollY = window.pageYOffset || docElement?.scrollTop || body?.scrollTop || 0

    return { scrollX, scrollY }
}

// NOTE: every contentLocation helper below returns VIEWPORT coordinates. The
// patched react-tiny-popover positions the popover container `fixed` whenever
// a contentLocation is in effect (and `absolute` for target-anchored mode), so
// scroll offsets must NOT be added here — that is what made these popovers
// invisible after scrolling and wobble while scrolling under the RNW 0.21
// layout, where the body (not the window) is the scroll container.
// A contentLocation function switches react-tiny-popover into "the caller
// places it" mode: the library skips its own nudging/reposition pass entirely,
// so whatever we return here is used verbatim on a `position: fixed`,
// `overflow: hidden` container. Every helper must therefore keep the popover
// inside the viewport itself. Centering without a clamp is what hid the swipe
// postpone popup on phones (AT-2189): a modal taller than a short mobile
// viewport centers to a NEGATIVE top, so its header and close button render
// above the top edge; and on a narrow screen the desktop sidebar offset pushes
// the container past the right edge, where `overflow: hidden` clips it.
// The math lives in utils/popoverPositioning.js so it can be unit-tested.
//
// Centers in the WINDOW on every screen size. It used to add half the sidebar
// width on desktop to center over the content area, but these popups dim the
// whole window (sidebar included), so the offset read as "not centered"
// (2026-08-12, same call as EndDayStatisticsModal). Callers still pass their
// legacy isMobile argument; it is deliberately ignored.
export const popoverToCenter = (positioningData = {}) => centerPopoverInWindow(positioningData, 0)

export const popoverToSafePosition = (
    { targetRect, popoverRect, position, align, nudgedLeft, nudgedTop },
    isMobile = true
) => {
    const dim = getWorkspaceViewport(Dimensions.get('window'))
    const sidebarDiff = isMobile ? 0 : SIDEBAR_MENU_WIDTH / 2
    const basePadding = 16 // Safe padding from screen edges
    // AT-2339: several of these call sites pass `disableReposition`, which
    // skips the patched library's own safe-area nudge, so the edge padding has
    // to absorb the iOS insets itself. Zero insets (desktop / Android) leave
    // every number below exactly as it was.
    const safeAreaInsets = getWorkspaceInsets(getSafeAreaInsets())
    const paddingTop = basePadding + safeAreaInsets.top
    const paddingBottom = basePadding + safeAreaInsets.bottom
    const paddingLeft = basePadding + safeAreaInsets.left
    const paddingRight = basePadding + safeAreaInsets.right
    const viewportWidth = dim.width
    const viewportHeight = dim.height

    // For mobile devices, use smart positioning based on available space
    if (isMobile) {
        // When targetRect is unavailable fall back to centered positioning.
        if (!targetRect || typeof targetRect.top !== 'number') {
            const centeredTop = clampToRange(
                viewportHeight / 2 - popoverRect.height / 2,
                paddingTop,
                viewportHeight - popoverRect.height - paddingBottom
            )
            const centeredLeft = clampToRange(
                viewportWidth / 2 - popoverRect.width / 2,
                paddingLeft,
                viewportWidth - popoverRect.width - paddingRight
            )

            return { top: dim.top + centeredTop, left: dim.left + centeredLeft }
        }

        const anchorGap = 8
        const targetTop = targetRect.top - dim.top
        const targetBottom =
            (targetRect.bottom == null ? null : targetRect.bottom - dim.top) ?? targetTop + (targetRect.height ?? 0)
        const targetLeft = (targetRect.left ?? dim.left) - dim.left
        const targetRight =
            (targetRect.right == null ? null : targetRect.right - dim.left) ?? targetLeft + (targetRect.width ?? 0)

        // Prefer showing the popover underneath the trigger, but flip when needed.
        let top = targetBottom + anchorGap
        const maxTop = viewportHeight - popoverRect.height - paddingBottom

        if (top + popoverRect.height > viewportHeight - paddingBottom) {
            const aboveTop = targetTop - popoverRect.height - anchorGap
            if (aboveTop >= paddingTop) {
                top = aboveTop
            } else {
                top = clampToRange(top, paddingTop, maxTop)
            }
        } else {
            top = clampToRange(top, paddingTop, maxTop)
        }

        const desiredLeft = targetRight - popoverRect.width
        const minLeft = paddingLeft
        const maxLeft = viewportWidth - popoverRect.width - paddingRight
        let left

        if (popoverRect.width > viewportWidth - paddingLeft - paddingRight) {
            left = clampToRange(
                viewportWidth / 2 - popoverRect.width / 2,
                minLeft,
                viewportWidth - popoverRect.width - safeAreaInsets.right
            )
        } else {
            left = clampToRange(desiredLeft, minLeft, maxLeft)
        }

        return { top: dim.top + top, left: dim.left + left }
    }

    // For desktop/tablet, use centered positioning with hard viewport clamping.
    // If the popover is taller than the available viewport, keep the top edge visible.
    let top = viewportHeight / 2 - popoverRect.height / 2
    let left = viewportWidth / 2 - popoverRect.width / 2 + sidebarDiff

    top = clampToRange(top, paddingTop, Math.max(paddingTop, viewportHeight - popoverRect.height - paddingBottom))
    left = clampToRange(left, paddingLeft, Math.max(paddingLeft, viewportWidth - popoverRect.width - paddingRight))

    return { top: dim.top + top, left: dim.left + left }
}

// Kept for explicitness at popoverToTop call sites; the patched
// react-tiny-popover applies fixed positioning for ANY active contentLocation,
// so this is redundant but harmless.
export const popoverToTopContainerStyle = { position: 'fixed' }

export const popoverToTop = ({ targetRect, popoverRect, position, align, nudgedLeft, nudgedTop }, isMobile = true) => {
    const dim = getWorkspaceViewport(Dimensions.get('window'))
    const sidebarDiff = isMobile ? 0 : SIDEBAR_MENU_WIDTH / 2
    const left = dim.width / 2 - popoverRect.width / 2
    // AT-2339, minimum semantics: this is the comment popup's placement, the
    // one surface already signed off as correct on a notched iPhone, and 80px
    // clears every current inset — so on those devices it does not move. The
    // floor only engages on a device whose status bar is taller than the
    // offset. The horizontal clamp is new: it keeps the card out of the
    // landscape cutout, which nothing here handled before. This helper is used
    // with `disableReposition`, so the library never nudges it.
    const safeAreaInsets = getWorkspaceInsets(getSafeAreaInsets())
    const maxLeft = Math.max(safeAreaInsets.left, dim.width - safeAreaInsets.right - popoverRect.width)

    return {
        top: dim.top + Math.max(FIXED_MODAL_TOP_OFFSET, safeAreaInsets.top),
        left: dim.left + clampToRange(left + sidebarDiff, safeAreaInsets.left, maxLeft),
    }
}

export const shortcutPreviewMount = () => {
    document.addEventListener('keydown', showShortcutsPreview)
    document.addEventListener('keyup', hideShortcutsPreview)
    document.addEventListener('click', hideShortcutsPreview)
    document.addEventListener('visibilitychange', hideShortcutsPreview)
    window.addEventListener('focus', hideShortcutsPreview)
    window.addEventListener('blur', hideShortcutsPreview)
}

export const shortcutPreviewUnmount = () => {
    document.removeEventListener('keydown', showShortcutsPreview)
    document.removeEventListener('keyup', hideShortcutsPreview)
    document.removeEventListener('click', hideShortcutsPreview)
    document.removeEventListener('visibilitychange', hideShortcutsPreview)
    window.removeEventListener('focus', hideShortcutsPreview)
    window.removeEventListener('blur', hideShortcutsPreview)
}

export const showShortcutsPreview = event => {
    if (store.getState().blockShortcuts) {
        return
    }
    if (event.altKey && !store.getState().showShortcuts) {
        store.dispatch(showShortcuts())
        setShortcutFocusedTasks()
        event.preventDefault()
    }
}

export const hideShortcutsPreview = e => {
    if (store.getState().showShortcuts) {
        store.dispatch(hideShortcuts())
    }
}

const setShortcutFocusedTasks = () => {
    const { focusedTaskItem } = store.getState()
    const taskListEls = document.querySelectorAll('[aria-task-id]')

    if (taskListEls.length > 0) {
        if (focusedTaskItem.id === '') {
            store.dispatch(
                setShortcutFocusTasks({
                    current: taskListEls[0].getAttribute('aria-task-id'),
                    prev: '',
                    next: '',
                })
            )
        } else {
            const taskListIds = []
            taskListEls.forEach(el => taskListIds.push(el.getAttribute('aria-task-id')))

            let index = taskListIds.indexOf(focusedTaskItem.id)
            let indexPrev = index === 0 ? taskListIds.length - 1 : index - 1
            let indexNext = index === taskListIds.length - 1 ? 0 : index + 1
            store.dispatch(
                setShortcutFocusTasks({
                    current: focusedTaskItem.id,
                    prev: taskListIds[indexPrev],
                    next: taskListIds[indexNext],
                })
            )
        }
    }
}

export const shortcutNotePreviewMount = () => {
    document.addEventListener('keydown', showNoteShortcutsPreview)
    document.addEventListener('keyup', hideNoteShortcutsPreview)
    document.addEventListener('click', hideNoteShortcutsPreview)
    document.addEventListener('visibilitychange', hideNoteShortcutsPreview)
    window.addEventListener('focus', hideNoteShortcutsPreview)
    window.addEventListener('blur', hideNoteShortcutsPreview)
}

export const shortcutNotePreviewUnmount = () => {
    document.removeEventListener('keydown', showNoteShortcutsPreview)
    document.removeEventListener('keyup', hideNoteShortcutsPreview)
    document.removeEventListener('click', hideNoteShortcutsPreview)
    document.removeEventListener('visibilitychange', hideNoteShortcutsPreview)
    window.removeEventListener('focus', hideNoteShortcutsPreview)
    window.removeEventListener('blur', hideNoteShortcutsPreview)
}

export const showNoteShortcutsPreview = event => {
    if (store.getState().blockShortcuts) {
        return
    }
    if (event.altKey && !store.getState().showNoteAltShortcuts) {
        store.dispatch(showNoteAltShortcuts())
        event.preventDefault()
    }

    if ((event.ctrlKey || event.metaKey) && !store.getState().showNoteCtrlShortcuts) {
        store.dispatch(showNoteCtrlShortcuts())
        event.preventDefault()
    }
}

export const hideNoteShortcutsPreview = e => {
    if (store.getState().showNoteAltShortcuts) {
        store.dispatch(hideNoteAltShortcuts())
    }
    if (store.getState().showNoteCtrlShortcuts) {
        store.dispatch(hideNoteCtrlShortcuts())
    }
}

export const execShortcutFn = (ref, shortcutFunction, event) => {
    dom.findDOMNode(ref)?.click()
    shortcutFunction()
    event?.preventDefault()
}

export const isInputsFocused = () => {
    const activeElement = document.activeElement
    const inputs = ['input', 'textarea']
    const isQuillFocused = activeElement.classList.contains('ql-editor')
    return (activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1) || isQuillFocused
}

export const calculateTimeDuration = secs => {
    let hr = Math.floor(secs / 3600)
    let min = Math.floor((secs - hr * 3600) / 60)
    let sec = Math.floor(secs - hr * 3600 - min * 60)
    if (min < 10) min = '0' + min
    if (sec < 10) sec = '0' + sec
    if (hr <= 0) return min + ':' + sec
    return hr + ':' + min + ':' + sec
}

export const getPopoverWidth = () => {
    const { isMiddleScreen: tablet, smallScreenNavigation: mobile } = store.getState()
    if (!mobile) return tablet ? POPOVER_TABLET_WIDTH : POPOVER_DESKTOP_WIDTH
    // Mobile popups use the full window width minus the gutter; the fixed
    // POPOVER_MOBILE_WIDTH card survives only as the fallback for the moments
    // the window width is not measurable yet.
    const { width: windowWidth } = getWorkspaceViewport(Dimensions.get('window'))
    // AT-2339: the landscape cutout on a notched iPhone eats ~59px off ONE
    // side, so "full window width minus the gutter" is wider than the space
    // that actually exists and the card overhangs whichever edge the popover
    // does not get clamped to. Zero insets give back `windowWidth - 32`.
    const fullWidth = getSafeAreaModalMaxWidth(windowWidth)
    return fullWidth > 0 ? fullWidth : POPOVER_MOBILE_WIDTH
}

export const applyPopoverWidth = (setMin = true, setMax = true) => {
    const desiredWidth = getPopoverWidth()
    const { width: windowWidth } = getWorkspaceViewport(Dimensions.get('window'))
    const availableWidth = getSafeAreaModalMaxWidth(windowWidth)
    const resolvedWidth = availableWidth > 0 ? Math.min(desiredWidth, availableWidth) : desiredWidth
    const width = resolvedWidth > 0 ? resolvedWidth : desiredWidth
    const min = { minWidth: width }
    const max = { maxWidth: width }
    const exact = setMin && setMax && width ? { width } : {}
    return { ...(setMin ? min : {}), ...(setMax ? max : {}), ...exact }
}

const getPopoverWidthv2 = (isMiddleScreen, smallScreenNavigation, windowWidth) => {
    const { left: safeLeft, right: safeRight } = getWorkspaceInsets(getSafeAreaInsets())
    return smallScreenNavigation
        ? windowWidth - 50 - safeLeft - safeRight
        : isMiddleScreen
          ? POPOVER_TABLET_WIDTH_V2
          : POPOVER_DESKTOP_WIDTH_V2
}

export const applyPopoverWidthV2 = (isMiddleScreen, smallScreenNavigation, windowWidth) => {
    const width = getPopoverWidthv2(isMiddleScreen, smallScreenNavigation, windowWidth)
    const viewport = getWorkspaceViewport()
    if (viewport.active) {
        const available = getSafeAreaModalMaxWidth(viewport.width)
        const resolved = Math.min(Math.max(width, POPOVER_MOBILE_WIDTH), available)
        return { minWidth: resolved, maxWidth: resolved }
    }
    return { minWidth: width > POPOVER_MOBILE_WIDTH ? width : POPOVER_MOBILE_WIDTH, maxWidth: width }
}

export const forceCloseModals = tryToRemove => {
    const containers = document.querySelectorAll('.react-tiny-popover-container')
    if (containers.length > 0) registerPopupDismiss()
    containers.forEach(e => {
        if (e?.parentNode) e?.parentNode?.click?.()
        else if (tryToRemove) e?.remove?.()
    })
}

export const dismissAllPopups = (tryToHide = false, tryToRemove = false, resetModals = false) => {
    if (tryToHide) store.dispatch(hideFloatPopup())
    forceCloseModals(tryToRemove)
    if (resetModals) store.dispatch(resetOpenModal())
}

export const dismissPopupInBackground = (modalId, condition = true, time = 2500) => {
    const modal = document.getElementById(modalId)
    if (modal && condition) {
        setTimeout(() => {
            if (modal && condition) {
                modal.remove()
            }
        }, time)
    }
}

const fallbackCopyTextToClipboard = text => {
    let textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        let successful = document.execCommand('copy')
        let msg = successful ? 'successful' : 'unsuccessful'
        // console.log('Fallback: Copying text command was ' + msg)
    } catch (err) {
        // console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
}
export const copyTextToClipboard = text => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
    }
    navigator.clipboard.writeText(text).then(
        function () {
            // console.log('Async: Copying to clipboard was successful!')
        },
        function (err) {
            // console.error('Async: Could not copy text: ', err)
        }
    )
}

export function getFileSize(projectId, url, uid) {
    let fileSize = ''
    let http = new XMLHttpRequest()
    http.open('GET', url, true) // true = Asynchronous
    http.onreadystatechange = function () {
        if (this.readyState == this.DONE) {
            if (this.status === 200) {
                fileSize = this.getResponseHeader('content-length')
                updateQuotaTraffic(projectId, uid, Number(fileSize) / 1024 / 1024)
            }
        }
    }
    http.send()
}

export const parseLastEdit = async (lastEditDate, setEditionText) => {
    const tablet = store.getState().isMiddleScreen
    const serverDate = await Backend.getFirebaseTimestampDirectly()

    if (serverDate) {
        setEditionText(formatLastEditDate(serverDate, lastEditDate, { tablet, dateFormat: getDateFormat() }))
    }
}

export const getCustomStyle = (inTaskDV, user, inFeedComment) => {
    return inTaskDV
        ? [{ height: 32, paddingRight: 12, paddingLeft: 7 }, user && { paddingLeft: 4 }]
        : inFeedComment
          ? { minHeight: 20, height: 20, paddingRight: 6 }
          : { height: 24, paddingRight: 8 }
}

export default HelperFunctions
